<template>
  <!-- 3~6岁儿童健康检查记录表 -->
  <div v-if="model && model.ageChildren">
    <div id="print_ageChildren" class="page ageChildren-page">
      <div style="height: 15px;"/>
      <div style="margin-top:15px;margin-bottom:15px;line-height: 1.2;font-weight: 600;letter-spacing: 5px;font-size: 23px !important;"><span>{{ model.ageChildren.reportName ? model.ageChildren.reportName : "3~6岁儿童健康检查记录表" }}</span></div>

      <table class="header" style="padding-left: 10px;text-align: left;font-size: 14px;border-collapse: collapse;width: 100%;">
        <tbody>
          <tr style="height: 30px;font-size: 13px;border:none;">
            <td style="width: 15%;border-collapse: collapse;border:none;">姓名：<span>{{ model.ageChildren.name ? model.ageChildren.name : "" }}</span></td>
            <td style="width: 10%;border-collapse: collapse;border:none;">性别：<span>{{ model.ageChildren.sex ? model.ageChildren.sex : "" }}</span></td>
            <td style="width: 22%;border-collapse: collapse;border:none;">出生日期：<span>{{ model.ageChildren.birthday ? model.ageChildren.birthday : "" }}</span></td>
            <td style="width: 18%;border-collapse: collapse;border:none;">班级：<span>{{ model.ageChildren.className ? model.ageChildren.className : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">幼儿园：<span>{{ model.ageChildren.schoolName ? model.ageChildren.schoolName : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table width="700" style="text-align: center;font-size: 12px;border-collapse: collapse;width: 100%;">
        <tbody>
          <tr>
            <td colspan="2" style="width: 120px;border-collapse: collapse;border: 1px solid black;">月（年）龄</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">{{ item.monthAge }}</td>
          </tr>
          <tr>
            <td colspan="2" style="width: 120px;border-collapse: collapse;border: 1px solid black;">随访日期</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">{{item.followUpDate ? item.followUpDate : ""}}</td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">体重/kg</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <input style="width: 40px;border-bottom: 1px solid black;border-top: none;border-left: none;border-right: none;margin-bottom: 3px;" :value="item.weight?item.weight:''"/>
              <span :class="{'evaluateContent' : item.weightAssessment&&item.weightAssessment.indexOf('上') > -1 }">上&nbsp;&nbsp;</span>
              <span :class="{'evaluateContent' : item.weightAssessment&&item.weightAssessment.indexOf('中') > -1 }">中&nbsp;&nbsp;</span>
              <span :class="{'evaluateContent' : item.weightAssessment&&item.weightAssessment.indexOf('下') > -1 }">下</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">身长(高)/cm</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <input style="width: 40px;border-bottom: 1px solid black;border-top: none;border-left: none;border-right: none;margin-bottom: 3px;" :value="item.height?item.height:''"/>
              <span :class="{'evaluateContent' : item.heightAssessment&&item.heightAssessment.indexOf('上') > -1 }">上&nbsp;&nbsp;</span>
              <span :class="{'evaluateContent' : item.heightAssessment&&item.heightAssessment.indexOf('中') > -1 }">中&nbsp;&nbsp;</span>
              <span :class="{'evaluateContent' : item.heightAssessment&&item.heightAssessment.indexOf('下') > -1 }">下</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">体重/身高</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <input style="width: 40px;border-bottom: 1px solid black;border-top: none;border-left: none;border-right: none;margin-bottom: 3px;" :value="item.weightHeight?item.weightHeight:''"/>
              <span :class="{'evaluateContent' : item.bmiAssessment&&item.bmiAssessment.indexOf('上') > -1 }">上&nbsp;&nbsp;</span>
              <span :class="{'evaluateContent' : item.bmiAssessment&&item.bmiAssessment.indexOf('中') > -1 }">中&nbsp;&nbsp;</span>
              <span :class="{'evaluateContent' : item.bmiAssessment&&item.bmiAssessment.indexOf('下') > -1 }">下</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">体格发育评估</td>
            <td style="text-align: left;margin-top: 5px;margin-bottom: 5px;padding-left: 15px;border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <div>
                <span :class="{'evaluateContent' : item.physicalDevelopmentAssessment&&item.physicalDevelopmentAssessment.indexOf('正常') > -1}">1 正常</span> &nbsp;&nbsp;&nbsp;
                <span :class="{'evaluateContent' : item.physicalDevelopmentAssessment&&item.physicalDevelopmentAssessment.indexOf('低体重') > -1}">2 低体重</span>
              </div>
              <div>
                <span :class="{'evaluateContent' : item.physicalDevelopmentAssessment&&item.physicalDevelopmentAssessment.indexOf('消瘦') > -1}">3 消瘦</span> &nbsp;&nbsp;&nbsp;
                <span :class="{'evaluateContent' : item.physicalDevelopmentAssessment&&item.physicalDevelopmentAssessment.indexOf('生长迟缓') > -1}">4 生长迟缓</span>
              </div>
              <div>
                <span :class="{'evaluateContent' : item.physicalDevelopmentAssessment&&item.physicalDevelopmentAssessment.indexOf('超重') > -1}">5 超重</span> &nbsp;&nbsp;&nbsp;
                <span :class="{'evaluateContent' : item.physicalDevelopmentAssessment&&item.physicalDevelopmentAssessment.indexOf('肥胖') > -1}">6 肥胖</span>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="7" style="width: 20px;border-collapse: collapse;border: 1px solid black;writing-mode: vertical-rl;text-orientation: upright;letter-spacing: 15px;"><span>体格评价</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">
              <div>S</div>
              <div>C</div>
              <div>A</div>
              <div>视力<span style="font-size: 12px;">(右/左)</span></div>
            </td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <div style="font-size: 12px;">
                <span :class="{'evaluateContent' : item.eyeCare&&item.eyeCare.indexOf('正常') > -1}">1 正常</span> &nbsp;&nbsp;
                <span :class="{'evaluateContent' : item.eyeCare&&item.eyeCare.indexOf('眼保健') > -1}">2 眼保健</span> &nbsp;&nbsp;
                <span :class="{'evaluateContent' : item.eyeCare&&item.eyeCare.indexOf('异常') > -1}">3 异常</span>
              </div>
              <div>{{item.rightSphericalMirror?item.rightSphericalMirror:""}} / {{item.leftSphericalMirror?item.leftSphericalMirror:""}}</div>
              <div>{{item.rightColumnMirror?item.rightColumnMirror:""}} / {{item.leftColumnMirror?item.leftColumnMirror:""}}</div>
              <div>{{item.rightAxisPosition?item.rightAxisPosition:""}} / {{item.leftAxisPosition?item.leftAxisPosition:""}}</div>
              <div>{{item.nakedRightEyeVision?item.nakedRightEyeVision:""}} / {{item.nakedLeftEyeVision?item.nakedLeftEyeVision:""}}</div>
            </td>
          </tr>
          <tr>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">听 力</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span :class="{'evaluateContent' : item.listening&&item.listening.indexOf('通过') > -1}">1.通过</span>&nbsp;&nbsp;
              <span :class="{'evaluateContent' : item.listening&&item.listening.indexOf('不通过') > -1}">2.不通过</span>
            </td>
          </tr>
          <tr>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">牙数(颗)/龋</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span>{{ item.numberTeeth != null || item.numberTeeth == 0 ? item.numberTeeth : "" }}</span>/
              <span>{{ item.cariesTotalNumber != null || item.cariesTotalNumber == 0 ? item.cariesTotalNumber : "" }}</span>
            </td>
          </tr>
          <tr>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">胸 部</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span :class="{'evaluateContent' : item.chest&&item.chest == '未见异常'}">1.未见异常</span> &nbsp;&nbsp;
              <span :class="{'evaluateContent' : item.chest&&item.chest == '异常'}">2.异常</span>
            </td>
          </tr>
          <tr>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">腹 部</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span :class="{'evaluateContent' : item.abdomen&&item.abdomen == '未见异常'}">1.未见异常</span> &nbsp;&nbsp;
              <span :class="{'evaluateContent' : item.abdomen&&item.abdomen == '异常'}">2.异常</span>
            </td>
          </tr>
          <tr>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;font-size: 13px">血红蛋白值、肝功能ALT</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span><input style="width: 40px;border-bottom: 1px solid black;border-top: none;border-left: none;border-right: none;margin-bottom: 3px;" :value="item.hemoglobinValue?item.hemoglobinValue:''"/>g/L&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span><input style="width: 40px;border-bottom: 1px solid black;border-top: none;border-left: none;border-right: none;margin-bottom: 3px;" :value="item.liverFunction?item.liverFunction:''"/>U/L</span>
            </td>
          </tr>
          <tr>
            <td style="width: 50px;height: 30px;border-collapse: collapse;border: 1px solid black;">其他</td>
            <td style="border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span>{{item.otherPhysicalExamination?item.otherPhysicalExamination:""}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">发育评估</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <template v-if="index===0">
                <div :class="{'evaluateContent' : item.developmentaAssessment&&(item.developmentaAssessment.indexOf('正常') > -1||item.developmentaAssessment.indexOf('通过') > -1)}">1.通过 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会说自己名字') > -1}">2.不会说自己名字 </div>
                <div :class='{"evaluateContent" : item.developmentaAssessment&&item.developmentaAssessment.indexOf("不会玩\"拿棍当马骑\"等假想游戏") > -1}'>3.不会玩“拿棍当马<br>骑”等假想游戏  </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会模仿画圈') > -1}">4.不会模仿画圈 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会双脚跳') > -1}">5.不会双脚跳 </div>
              </template>
              <template v-if="index===1">
                <div :class="{'evaluateContent' : item.developmentaAssessment&&(item.developmentaAssessment.indexOf('正常') > -1||item.developmentaAssessment.indexOf('通过') > -1)}">1.通过 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会说带形容词的句子') > -1}">2.不会说带形容词的<br>句子 </div>
                <div :class='{"evaluateContent" : item.developmentaAssessment&&item.developmentaAssessment.indexOf("不会按要求等待或轮流") > -1}'>3.不会按要求等待或<br>轮流 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会独立穿衣') > -1}">4.不会独立穿衣 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会单脚独立') > -1}">5.不会单脚独立 </div>
              </template>
              <template v-if="index===2">
                <div :class="{'evaluateContent' : item.developmentaAssessment&&(item.developmentaAssessment.indexOf('正常') > -1||item.developmentaAssessment.indexOf('通过') > -1)}">1.通过 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会简单叙说事情经过') > -1}">2.不会简单叙说事情<br>经过 </div>
                <div :class='{"evaluateContent" : item.developmentaAssessment&&item.developmentaAssessment.indexOf("不知道自己的性别") > -1}'>3.不知道自己的性别</div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会用筷子吃饭') > -1}">4.不会用筷子吃饭 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会单脚跳') > -1}">5.不会单脚跳 </div>
              </template>
              <template v-if="index===3">
                <div :class="{'evaluateContent' : item.developmentaAssessment&&(item.developmentaAssessment.indexOf('正常') > -1||item.developmentaAssessment.indexOf('通过') > -1)}">1.通过 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会表达自己的感受或想法') > -1}">2.不会表达自己的感<br>受或想法 </div>
                <div :class='{"evaluateContent" : item.developmentaAssessment&&item.developmentaAssessment.indexOf("不会玩角色扮演的集体游戏") > -1}'>3.不会玩角色扮演的<br>集体游戏 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('会画方形') > -1}">4.会画方形 </div>
                <div :class="{'evaluateContent' : item.developmentaAssessment&&item.developmentaAssessment.indexOf('不会奔跑') > -1}">5.不会奔跑 </div>
              </template>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">两次随访间患病情况</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <div :class="{'evaluateContent' : item.twoFollowSufferingIllness&&item.twoFollowSufferingIllness.indexOf('无') > -1}">1.无</div>
              <div :class="{'evaluateContent' : item.twoFollowSufferingIllness&&item.twoFollowSufferingIllness.indexOf('肺炎') > -1}">2.肺炎<div style="display: inline-block;text-align: center;min-width: 40px;border-bottom:1px solid black;">{{ item.pneumonia!=null&&item.pneumonia!=undefined?item.pneumonia:'' }}</div>次</div>
              <div :class="{'evaluateContent' : item.twoFollowSufferingIllness&&item.twoFollowSufferingIllness.indexOf('腹泻') > -1}">3.腹泻<div style="display: inline-block;text-align: center;min-width: 40px;border-bottom:1px solid black;">{{ item.diarrhea!=null&&item.diarrhea!=undefined?item.diarrhea:'' }}</div>次</div>
              <div :class="{'evaluateContent' : item.twoFollowSufferingIllness&&item.twoFollowSufferingIllness.indexOf('外伤') > -1}">4.外伤<div style="display: inline-block;text-align: center;min-width: 40px;border-bottom:1px solid black;">{{ item.trauma!=null&&item.trauma!=undefined?item.trauma:'' }}</div>次</div>
              <div :class="{'evaluateContent' : item.twoFollowSufferingIllness&&item.twoFollowSufferingIllness.indexOf('其他') > -1}">5.其他</div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">两次随访间意外伤害</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span :class="{'evaluateContent' : item.accidentalInjury&&item.accidentalInjury.indexOf('无') > -1}">1.无</span> &nbsp;&nbsp;
              <span :class="{'evaluateContent' : item.accidentalInjury&&item.accidentalInjury.indexOf('有') > -1}">2.有</span>
            </td>
          </tr>
          <tr style="line-height: 25px;">
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">高危儿</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <div :class="{'evaluateContent' : item.highRiskChildren&&item.highRiskChildren.indexOf('否') > -1}">1.否</div>
              <div :class="{'evaluateContent' : item.highRiskChildren&&item.highRiskChildren.indexOf('是') > -1}">
                2.是(管理：
                <span :class="{'evaluateContent' : item.highRiskChildrenManagement&&item.highRiskChildrenManagement.indexOf('无') > -1}">1.无</span>，
                <span :class="{'evaluateContent' : item.highRiskChildrenManagement&&item.highRiskChildrenManagement.indexOf('有') > -1}">2.有</span>
                )
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">转诊建议</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: left;padding-left: 15px;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <span :class="{'evaluateContent' : item.referralSuggestion&&(item.referralSuggestion==1||item.referralSuggestion.toString().indexOf('无') > -1)}">1.无</span> &nbsp;&nbsp;
              <span :class="{'evaluateContent' : item.referralSuggestion&&(item.referralSuggestion==2||item.referralSuggestion.toString().indexOf('有') > -1)}">2.有</span>
              <div>原因:<div style="display: inline-block;text-align: left;margin-bottom: -3px;min-width: 100px;border-bottom:1px solid black;">{{ item.reasonReferral?item.reasonReferral:'' }}</div></div>
              <div>机构及科室:
                <div style="display:inline-block;text-align: left;margin-bottom: 3px;min-width: 130px;border-bottom:1px solid black;">
                  {{ (item.reasonInstitution?item.reasonInstitution + ';':'') + (item.reasonDepartment?item.reasonDepartment:'') }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">指导</td>
            <td style="text-align: left;padding-left: 15px;border-collapse: collapse;border: 1px solid black;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <div :class="{'evaluateContent' : item.guidance&&item.guidance.indexOf('合理膳食') > -1}">1.合理膳食</div>
              <div :class="{'evaluateContent' : item.guidance&&item.guidance.indexOf('生长发育') > -1}">2.生长发育</div>
              <div :class="{'evaluateContent' : item.guidance&&item.guidance.indexOf('疾病预防') > -1}">3.疾病预防</div>
              <div :class="{'evaluateContent' : item.guidance&&item.guidance.indexOf('预防伤害') > -1}">4.预防伤害</div>
              <div :class="{'evaluateContent' : item.guidance&&item.guidance.indexOf('口腔保健') > -1}">5.口腔保健</div>
              <div :class="{'evaluateContent' : item.guidance&&item.guidance.indexOf('其他') > -1}">6.其他 <input style="width: 80px;border-bottom: 1px solid black;border-top: none;border-left: none;border-right: none;margin-bottom: 3px;" :value="item.otherContent?item.otherContent:''"/></div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">下次随访日期</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: center;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">{{item.nextFollowDate}}</td>
          </tr>
          <tr>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">随访医生签名</td>
            <td style="border-collapse: collapse;border: 1px solid black;text-align: center;" v-for="(item, index) in model.ageChildren.recored && model.ageChildren.recored.length > 0 ? model.ageChildren.recored : monthAges">
              <img :src="item.followUpDoctorSignature" style="height: 40px;object-fit: contain;" v-if="item.followUpDoctorSignature">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import {_ageChildren} from "@/services/report/report";
export default {
  name: "ageChildrenReport",
  props: {
    physicalId:[String,Number],
    barCode:[String,Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        ageChildren:{
          reportName: "",
          hospitalName: "",
          name: "",
          recored: []
        }
      },
      monthAges: [{monthAge:"3岁"}, {monthAge:"4岁"}, {monthAge:"5岁"}, {monthAge:"6岁"}],
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'ageChildren'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'ageChildren') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods:{
    loadData(){
      if(this.barCode){
        this.ageChildren(this.barCode);
      }
    },
    ageChildren(barCode) {
      _ageChildren({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
}
</script>

<style lang="postcss" scoped>

@media print {
  .ageChildren-page {
    page: ageChildren-page; /* 绑定唯一命名 */
  }
  @page ageChildren-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-left:25px;padding-right:25px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}
.evaluateContent {position: relative !important;top: 0;left: 1px;cursor: pointer;}
.evaluateContent::before {position: absolute;content: " ";width: 9px;height: 15px;-webkit-transform: rotate(45deg);transform: rotate(45deg);border-right: 2px solid #fd4245;border-bottom: 2px solid #fd4245;}

</style>

